import {ApiClient} from '@hconnect/apiclient'
import {spawnErrorToast, spawnSuccessToast} from '@hm/fundamental'
import {useMutation} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useErrorHandler} from 'react-error-boundary'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../consts'

interface SendBackupPlanError {
  detail?: string
}

interface SendBackupPlanPayload {
  plantCode: string
}

const sendBackupPlan = async ({plantCode}: SendBackupPlanPayload): Promise<void> => {
  await ApiClient.axiosInstance.post<void>(
    '/electricity/production-planning-backup',
    {},
    {params: {plantCode}}
  )
}

export const useSendBackupPlan = () => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const raiseError = useErrorHandler()
  return useMutation<void, AxiosError<SendBackupPlanError>, SendBackupPlanPayload>({
    mutationFn: sendBackupPlan,
    onError: (error) => {
      spawnErrorToast(t('error.backupPlanSent'))
      const detail = error.response?.data.detail
      if (typeof detail === 'string') spawnErrorToast(detail)
      else if (detail) raiseError(new Error(JSON.stringify(detail)))
    },
    onSuccess: () => {
      spawnSuccessToast(t('success.backupPlanSent'))
    }
  })
}
